import { Dispatch, SetStateAction, useContext, useRef, useState } from "react";
import AnimateHeight from "react-animate-height";
import { ReactComponent as ChevronDown } from "../../../../../../../../assets/SpecTools/chevron-down.svg";
import { ReactComponent as Delete } from "../../../../../../../../assets/SpecTools/delete.svg";
import Input from "../../../../../../../../components/Input/Input";
import { ContextProvider } from "../../../../../../../../contextProvider";
import { SpecialistTagsDirections } from "../../../../../../../../types/TypeSpecialist";
import useAutosizeTextArea from "../../../../../../../../utils/useAutosizeTextArea";
import { NewPackageType } from "../PackagesTool";
import s from "./PackageSessionCard.module.css";

type PackageSessionCardProps = {
  session: {
    title: {
      language: string;
      text: string;
    }[];
    description?: {
      language: string;
      text: string;
    }[];
    datesAndTime: {
      duration: number;
    }[];
    order: number;
    nextSessionGap: { min: number; max: number };
    specialization: SpecialistTagsDirections | string;
  };

  setSessionState: Dispatch<SetStateAction<NewPackageType>>;
  selectLang: string | undefined;
  showErrorFields: boolean;
  validateInput: (
    selectedLang: string | undefined,
    text:
      | {
          text: string;
          language: string;
        }[]
      | undefined
  ) => boolean;
};

const PackageSessionCard = ({
  session,
  setSessionState,
  selectLang,
  showErrorFields,
  validateInput,
}: PackageSessionCardProps) => {
  const { userData } = useContext(ContextProvider);
  const [cardIsOpen, setCardIsOpen] = useState(
    session.title[0] && session.title[0].text.length ? false : true
  );
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  useAutosizeTextArea(
    textAreaRef.current,
    session.description!.find((el) => el.language === selectLang)?.text!
  );

  const updateSessionField = (order: number, field: string, value: any) => {
    setSessionState((prevPackage) => {
      const updatedSessions = prevPackage.sessions.map((session) => {
        if (session.order === order) {
          if (field.startsWith("datesAndTime.")) {
            const [, nestedField] = field.split(".");
            return {
              ...session,
              datesAndTime: [
                {
                  ...session.datesAndTime[0],
                  [nestedField]: value,
                },
              ],
            };
          } else {
            return {
              ...session,
              [field]: value,
            };
          }
        }
        return session;
      });

      return { ...prevPackage, sessions: updatedSessions };
    });
  };
  const updateDuration = (order: number, operator: "plus" | "minus") => {
    if (session.datesAndTime[0].duration === (operator === "plus" ? 180 : 10))
      return;
    setSessionState((prevState) => {
      return {
        ...prevState,
        sessions: prevState.sessions.map((session) => {
          if (session.order === order) {
            return {
              ...session,
              datesAndTime: session.datesAndTime.map((dt, index) => {
                if (index === 0) {
                  return {
                    ...dt,
                    duration:
                      operator === "plus" ? dt.duration + 10 : dt.duration - 10,
                  };
                }
                return dt;
              }),
            };
          }
          return session;
        }),
      };
    });
  };
  const deleteSessionByOrder = (order: number) => {
    setSessionState((prevPackage) => {
      const updatedSessions = prevPackage.sessions
        .filter((session) => session.order !== order)
        .map((item, index) => ({ ...item, order: index + 1, id: index + 1 }));
      return { ...prevPackage, sessions: updatedSessions };
    });
  };

  return (
    <div className={s.container}>
      <div className={s.headCardBlock}>
        <div className={s.leftHeadBlock}>
          <ChevronDown
            className={s.chevronIcon}
            onClick={() => setCardIsOpen((prev) => !prev)}
          />
          <Input
            type="text"
            inputValue={
              session.title.find((el) => el.language === selectLang)?.text!
            }
            onChangeInput={(value) =>
              setSessionState((prevPackage) => {
                const updatedSessions = prevPackage.sessions.map((item) => {
                  if (session.order === item.order) {
                    return {
                      ...item,
                      title: item.title.map((el) =>
                        el.language === selectLang ? { ...el, text: value } : el
                      ),
                    };
                  }
                  return item;
                });

                return { ...prevPackage, sessions: updatedSessions };
              })
            }
            placeholder={"Type your title..."}
            disabled={!selectLang ? true : false}
            border={
              showErrorFields && validateInput(selectLang, session.title)
                ? "1px solid red"
                : "1px solid #DADADA"
            }
          />
        </div>
        <Delete
          onClick={() => deleteSessionByOrder(session.order)}
          className={s.deleteIcon}
        />
      </div>
      <AnimateHeight height={cardIsOpen ? "auto" : 0}>
        <div className={s.durationBlock}>
          <span className={s.inputLable}>Duration (min)</span>
          <div className={s.durationInput}>
            <span
              className={s.durationBtn}
              onClick={() => updateDuration(session.order, "minus")}
            >
              -
            </span>
            <span>{session.datesAndTime[0].duration}</span>
            <span
              className={s.durationBtn}
              onClick={() => updateDuration(session.order, "plus")}
            >
              +
            </span>
          </div>
          <span className={s.inputLable}>
            Specify the minimum and maximum number of days available for booking
            the next session
          </span>
          <div className={s.gapInputsBlock}>
            <div className={s.gapInput}>
              <Input
                inputValue={session.nextSessionGap.min.toString()}
                onChangeInput={(value) => {
                  /*   const numericValue = value === "" ? 0 : Number(value);
                  if (Number.isInteger(numericValue) && numericValue >= 0) {
                   
                  } */
                  updateSessionField(session.order, "nextSessionGap", {
                    min: value,
                    max: session.nextSessionGap.max,
                  });
                }}
                isVisible
                required
                placeholder="min"
                lable="Min"
                type="number"
                maxNumber={14}
                minNumber={1}
                disabled={!selectLang ? true : false}
              />
            </div>{" "}
            <div className={s.gapInput}>
              <Input
                inputValue={session.nextSessionGap.max.toString()}
                onChangeInput={(value) => {
                  /*   const numericValue = value === "" ? 0 : Number(value);

                  if (Number.isInteger(numericValue) && numericValue >= 0) {
                  
                  } */
                  updateSessionField(session.order, "nextSessionGap", {
                    min: session.nextSessionGap.min,
                    max: value,
                  });
                }}
                isVisible
                required
                placeholder="max"
                lable="Max"
                type="number"
                maxNumber={14}
                minNumber={1}
                disabled={!selectLang ? true : false}
              />
            </div>
          </div>
          {/* <input
            type="number"
            value={session.datesAndTime[0].duration}
            className={s.durationInput}
            onChange={(e) =>
              updateSessionField(
                session.order,
                "datesAndTime.duration",
                e.target.value
              )
            }
          /> */}
        </div>
        <div className={s.descriptionBlock}>
          <span className={s.inputLable}>Description</span>
          <textarea
            rows={2}
            name=""
            id=""
            ref={textAreaRef}
            value={
              session.description!.find((el) => el.language === selectLang)
                ?.text!
            }
            onChange={(e) =>
              setSessionState((prevPackage) => {
                const updatedSessions = prevPackage.sessions.map((item) => {
                  if (session.order === item.order) {
                    return {
                      ...item,
                      description: item.description!.map((el) =>
                        el.language === selectLang
                          ? { ...el, text: e.target.value }
                          : el
                      ),
                    };
                  }
                  return item;
                });

                return { ...prevPackage, sessions: updatedSessions };
              })
            }
            className={s.descriptionTextArea}
            disabled={!selectLang ? true : false}
          ></textarea>
        </div>
      </AnimateHeight>
    </div>
  );
};

export default PackageSessionCard;
